import axios from 'axios'
import objectToFormData from '../utils/object-to-form-data'

export class BaseService {
  constructor(resource) {
    this.base = '/api/v1'
    this.url = `${this.base}/${resource}`
    this.resourceUrl =
      resource !== 'users' && resource !== 'patients'
        ? `${this.base}/${resource}`
        : `${this.base}`
  }

  /**
   * Sends a get request to the backend to receive
   * the resource by a certain id
   * @param {Number} id
   * @returns {Promise} Promise object with data from axios get call
   */
  get(id, params) {
    if (id) return axios.get(`${this.url}/${id}`)
    else return axios.get(this.url, { params: params })
  }

  /**
   * Sends a put request to the backend to update
   * the resource by a certain id
   * @param {Number} id
   * @param {Object} data
   * @returns {Promise} Promise object with data from axios put call
   */
  update(id, data) {
    return axios.put(`${this.url}/${id}`, data)
  }

  /**
   * Sends a post request to the backend to create
   * a resource
   * @param {Object} data
   * @returns Promise object with data from axios post call
   */
  create(data) {
    return axios.post(`${this.url}/`, data)
  }

  /**
   * Sends a delete request to the backend to delete
   * a resource
   * @param {Number} id
   * @returns Promise object with data from axios post call
   */
  delete(id) {
    return axios.delete(`${this.url}/${id}`)
  }

  /**
   * Sends a get request to the backend to receive
   * the resource's options
   * @returns
   */
  options() {
    return axios.get(`${this.resourceUrl}/options/`)
  }

  /**
   * Sends a post request to the backend to upload an attachment
   *
   * @param {Object} files
   * @returns {Promise} Promise object represents axios post call
   */
  attachments(files, objectId, objectType) {
    return axios.post(
      `${this.base}/hr/${objectId}/attachment/`,
      objectToFormData({
        content_type: objectType,
        content_object_id: objectId,
        file: files,
      }),
      {
        'Content-Type': 'multipart/form-data',
      }
    )
  }

  /**
   * Sends a delete request to the backend to delete an attachment
   *
   * @param {Number} id
   * @returns {Promise} Promise object represents axios delete call
   */
  attachmentDelete(id) {
    return axios.delete(`${this.base}/hr/attachment/${id}`)
  }
}
